module.exports = __webpack_public_path__ + "img/react.389ef15c.svg";